/**
 * Indexavtal · Version 2026 — indexavtal v1 (Formulär R-08).
 *
 * Exists only as a bilaga under a lokalhyresavtal (`attachableTo`,
 * singleton per parent) and is signed with it; it has no parties or
 * signing roster of its own. Party and contract details are snapshotted
 * from the parent into slot values.
 */
import { applyDefaults, COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { declaredSectionInstances } from '../common/index.js';
import { INDEXAVTAL_BLOCKS } from '../indexavtal/blocks.js';
const K = 'indexavtal';
const TITLE = 'Indexavtal · Version 2026';
const FORM_NUMBER = 'Formulär R-08';
const PREAMBLE = 'Mellan hyresvärd och hyresgäst har följande avtal om indexering ingåtts.';
const SLOTS = INDEXAVTAL_BLOCKS.flatMap((b) => b.slots);
export const indexavtalV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'indexavtal',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Lokalhyra',
        numberStyle: 'paragraph',
        shortTitle: 'Indexavtal',
        formNumber: FORM_NUMBER,
        preamble: PREAMBLE,
        description: 'Indexreglering av hyran i ett lokalhyresavtal. Tillägg till hyran ' +
            'beräknas på bashyran utifrån förändringar i konsumentprisindex ' +
            '(KPI, basår 2020).\n\n' +
            'Skapas endast som bilaga under ett lokalhyresavtal — visas inte i ' +
            'avtalslistan, har ingen egen signering. Bifogas det signerade ' +
            'avtalet automatiskt vid utskick via Scrive.',
        status: 'active',
        signingMode: 'parent',
        attachableTo: ['lokalhyra'],
        singletonPerParent: true,
        partySlots: [],
    },
    values: applyDefaults({ fields: SLOTS }, values),
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PREAMBLE } },
        ...declaredSectionInstances([
            { ref: 'hyresvard', blockRef: `${K}.hyresvard@v1` },
            { ref: 'hyresgast', blockRef: `${K}.hyresgast@v1`, besidePrevious: true },
            { ref: 'avtalskoppling', blockRef: `${K}.avtalskoppling@v1` },
            { ref: 'indexreglering', blockRef: `${K}.indexreglering@v1` },
        ], { customBlockRef: `${K}.custom-sections@v1` }),
        { instanceId: 'signeringsnotis', blockRef: `${K}.signeringsnotis@v1`, input: {} },
    ],
});
//# sourceMappingURL=indexavtal.js.map